/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEaseIn = createReactComponent("ease-in", "IconEaseIn", [
  ["path", { d: "M3 20c8 0 18 -16 18 -16", key: "svg-0" }]
]);

export { IconEaseIn as default };
//# sourceMappingURL=IconEaseIn.js.map
